export { default as LottieAnimation } from "./LottieAnimation";
